var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2783_55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.09375 14.0625H5.78125C6.38437 14.0625 6.875 13.5719 6.875 12.9688V1.09375C6.875 0.490625 6.38437 0 5.78125 0H1.09375C0.490625 0 0 0.490625 0 1.09375V12.9688C0 13.5719 0.490625 14.0625 1.09375 14.0625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5312 3.75H8.59375C8.335 3.75 8.125 3.96 8.125 4.21875C8.125 4.4775 8.335 4.6875 8.59375 4.6875H14.5312C14.79 4.6875 15 4.4775 15 4.21875C15 3.96 14.79 3.75 14.5312 3.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5312 1.875H8.59375C8.335 1.875 8.125 2.085 8.125 2.34375C8.125 2.6025 8.335 2.8125 8.59375 2.8125H14.5312C14.79 2.8125 15 2.6025 15 2.34375C15 2.085 14.79 1.875 14.5312 1.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5312 0H8.59375C8.335 0 8.125 0.21 8.125 0.46875C8.125 0.7275 8.335 0.9375 8.59375 0.9375H14.5312C14.79 0.9375 15 0.7275 15 0.46875C15 0.21 14.79 0 14.5312 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5312 5.625H8.59375C8.335 5.625 8.125 5.835 8.125 6.09375C8.125 6.3525 8.335 6.5625 8.59375 6.5625H14.5312C14.79 6.5625 15 6.3525 15 6.09375C15 5.835 14.79 5.625 14.5312 5.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5312 7.5H8.59375C8.335 7.5 8.125 7.71 8.125 7.96875C8.125 8.2275 8.335 8.4375 8.59375 8.4375H14.5312C14.79 8.4375 15 8.2275 15 7.96875C15 7.71 14.79 7.5 14.5312 7.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5312 9.375H8.59375C8.335 9.375 8.125 9.585 8.125 9.84375C8.125 10.1025 8.335 10.3125 8.59375 10.3125H14.5312C14.79 10.3125 15 10.1025 15 9.84375C15 9.585 14.79 9.375 14.5312 9.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5312 11.25H8.59375C8.335 11.25 8.125 11.46 8.125 11.7188C8.125 11.9775 8.335 12.1875 8.59375 12.1875H14.5312C14.79 12.1875 15 11.9775 15 11.7188C15 11.46 14.79 11.25 14.5312 11.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5312 13.125H8.59375C8.335 13.125 8.125 13.335 8.125 13.5938C8.125 13.8525 8.335 14.0625 8.59375 14.0625H14.5312C14.79 14.0625 15 13.8525 15 13.5938C15 13.335 14.79 13.125 14.5312 13.125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2783_55"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboardIcon.4e0fe3ceb03a637e05b65996d8f06114.svg";
export { ForwardRef as ReactComponent };